import React from 'react';
import {
  ReviewDataWrapper,
  ReviewCommentWrapper,
  ReviewerNameWrapper,
  ReplyCommentWrapper,
  ReviewerApplyNameWrapper,
  StyledOpacityWrapper,
  ReviewCardContainer,
  StyledDealerCommentType,
} from './styled';
import { DealerComment } from '../../typings/dealer-review';
import { AppConstants } from '../../utils/app-constants';
import { getRatingPercent } from '../../utils/general';
import CollapseText from '../collapse-text';
import { CommentWriter } from '../comment-writer';
import FiveStars from '../five-stars';
import { FormattedDate } from '../formated-date';
import { TextAppearance, TextCustom } from '@vw-marketing/us-components';
interface DealerReviewCommentProps {
  review: DealerComment;
  minHeight?: number;
  opacity?: boolean;
  onHandleChangeTracking: (state: boolean) => void;
}
const DealerReviewComment: React.FC<DealerReviewCommentProps> = (
  props,
): JSX.Element => {
  const { review, opacity, onHandleChangeTracking } = props;

  // Component Constants
  const replyLabel = 'Volkswagen response';
  const starSize = '18px';
  const commentLines = 3;
  const textLineHeight = 1.5; // 24px to em base on 16px

  return (
    <ReviewCardContainer className="Review-card-container">
      <StyledOpacityWrapper isOpacity={opacity} />
      <StyledDealerCommentType>
        <div className='comment-type-wrapper'>
        <TextCustom appearance={TextAppearance.copy100}>
          {' '}
          {review.category_key.toUpperCase()} REVIEWS
        </TextCustom>
        </div>
        
      </StyledDealerCommentType>
      <ReviewerNameWrapper>
        <CommentWriter writer={review.reviewer.displayName} />
      </ReviewerNameWrapper>
      <ReviewDataWrapper>
        <FiveStars
          percent={getRatingPercent(parseInt(review.comment_rating))}
          starColor={AppConstants.StarColor as string}
          background={AppConstants.StarBackground as string}
          starSize={starSize}
        />
        <FormattedDate date={review.comment_date} />
      </ReviewDataWrapper>
      <ReviewCommentWrapper>
        <CollapseText
          text={review.comment_text}
          lines={commentLines}
          lineHeight={textLineHeight}
          noFadeTextWrapper
          setStateContainer={onHandleChangeTracking}
        />
      </ReviewCommentWrapper>
      {review.dealer_response && review.dealer_response.dealer_response_text && (
        <ReplyCommentWrapper>
          <ReviewerApplyNameWrapper>
            <div>
              <CommentWriter writer={replyLabel} />
            </div>
            <FormattedDate date={review.dealer_response.dealer_response_date} />
          </ReviewerApplyNameWrapper>
          <ReviewCommentWrapper>
            <CollapseText
              text={review.dealer_response.dealer_response_text}
              lines={commentLines}
              lineHeight={textLineHeight}
              noFadeTextWrapper
            />
          </ReviewCommentWrapper>
        </ReplyCommentWrapper>
      )}
    </ReviewCardContainer>
  );
};
export default DealerReviewComment;
